import { useEffect, useRef } from 'react';

import { useSharedCheckoutContext } from '@root/components/checkout/context';
import { isStorageCheckoutFlowVersion } from '@root/components/checkout/types';
import { EventSchema } from '@root/resources/wt/types';

import { useTrackFunnelEvents } from '@utils/hooks/funnel_events/use_track_funnel_event';

export const useFlowInitiatedFunnelEvents = () => {
  const {
    flowVersion,
    flowState: {
      values: { zipValidated, zip },
    },
  } = useSharedCheckoutContext();
  const trackFunnelEvent = useTrackFunnelEvents();
  const zipValidatedEmittedRef = useRef(false);

  useEffect(() => {
    trackFunnelEvent({
      schema: EventSchema.WWW__FlowInitiated,
      action: 'display',
      metadata: { zip },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!zipValidated || !zip || zipValidatedEmittedRef.current) {
      return;
    }
    zipValidatedEmittedRef.current = true;
    trackFunnelEvent({
      schema: EventSchema.WWW__ZipValidated,
      action: 'click',
      metadata: {
        service: isStorageCheckoutFlowVersion(flowVersion)
          ? 'storage'
          : 'moving',
        zip,
      },
    });
  }, [zipValidated, zip, flowVersion, trackFunnelEvent]);
};
